import React from 'react';
import { Image } from 'bootstrap';

/**
 * Event Avatar
 *
 */
export default React.createClass({
  displayName: 'EventAvatar',

  propTypes: {
    uri: React.PropTypes.string,
  },

  render() {
    const { uri } = this.props;

    if (!uri) return null;

    return (
      <div className="event-avatar">
        <Image responsive src={uri} alt="event avatar" />
      </div>
    );
  },
});
